// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-qvum5J{width:100%;height:100%}.content-f96EdF{flex-direction:column;align-items:center;margin:auto;padding-top:35.39vh;display:flex}.title-t8XbJw{margin-top:24px!important;margin-bottom:4px!important;font-size:16px!important;font-weight:600!important;line-height:22px!important}.paragraph-l6Yyho{color:rgba(29,28,35,.6)!important;margin-bottom:24px!important;font-size:12px!important;line-height:16px!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper-qvum5J`,
	"content": `content-f96EdF`,
	"title": `title-t8XbJw`,
	"paragraph": `paragraph-l6Yyho`
};
export default ___CSS_LOADER_EXPORT___;
